module.exports = __webpack_public_path__ + "img/stent1_no.3c4da1a3.png";